// Compiled at 2026-05-13T13:50:05.286Z
// Compiled at 2026-05-13T13:50:05.286Z
// Compiled at 2026-05-13T13:50:05.286Z
import { validationRequired, state_validationRequired } from "./Common/validationRequired.js";
import { validationEmail, state_validationEmail } from "./Common/validationEmail.js";
import { search, state_search } from "./Common/search.js";
import { German, state_German } from "./Common/German.js";
import { English, state_English } from "./Common/English.js";
import { Common, state_Common } from "./Common/Common.js";

export type AppState = {
    readonly validationRequired: validationRequired,
    readonly validationEmail: validationEmail,
    readonly search: search,
    readonly german: German,
    readonly english: English,
    readonly common: Common
};

export const app: AppState = {
    get validationRequired() { return state_validationRequired },
    get validationEmail() { return state_validationEmail },
    get search() { return state_search },
    get german() { return state_German },
    get english() { return state_English },
    get common() { return state_Common }
};
